/**
 * Regras de elegibilidade de itens para execução de ações.
 *
 * Hoje a única restrição é sobre linhas eSIMs: ações que não permitem
 * eSIMs (fl_esim !== 1) e que não são ações "pré-selecionadas"
 * (fl_selecionado !== 1) devem remover os itens com fl_esim === 1 da
 * seleção antes de executar.
 *
 * Se novas regras de elegibilidade surgirem, adicionar aqui
 * mantendo este módulo como única fonte de verdade.
 */

/**
 * Indica se a ação permite eSIMs.
 * @param {object} acao
 * @returns {boolean}
 */
export const acaoPermiteEsim = (acao) =>
  acao?.fl_esim == 1 || acao?.fl_selecionado == 1

/**
 * Retorna os itens selecionados que NÃO são elegíveis para executar a ação.
 *
 * @param {Array<object>} itens - Lista atual de itens selecionados.
 * @param {object} acao - Metadados da ação (fl_esim, fl_selecionado, ds_acao...).
 * @returns {Array<object>} Subconjunto dos itens considerado inelegível.
 */
export const getLinhasInvalidasEsim = (itens = [], acao) => {
  if (!Array.isArray(itens) || itens.length === 0) return []
  if (acaoPermiteEsim(acao)) return []

  return itens.filter((item) => item?.fl_esim === 1)
}

/**
 * Indica se todos os itens selecionados são inelegíveis para a ação.
 *
 * @param {Array<object>} itens
 * @param {object} acao
 * @returns {boolean}
 */
export const todasLinhasInvalidas = (itens = [], acao) => {
  if (!Array.isArray(itens) || itens.length === 0) return false
  const invalidas = getLinhasInvalidasEsim(itens, acao)
  return invalidas.length === itens.length
}
